import { useCallback, useEffect, useMemo, useState } from 'react';
import type { RefObject } from 'react';
import type React from 'react';

import { ShadowPosition } from 'src/modules/renderings/components/common/types';

export const useScrollShadowPosition = (ref: RefObject<HTMLDivElement>) => {
  const [shadowPosition, setShadowPosition] = useState(ShadowPosition.NONE);

  useEffect(() => {
    if (ref.current) {
      const observer = new ResizeObserver(e => {
        const { scrollHeight, clientHeight } = e[0].target;
        setShadowPosition(
          scrollHeight === clientHeight
            ? ShadowPosition.NONE
            : ShadowPosition.TOP,
        );
      });
      observer.observe(ref.current);
    }
  }, [setShadowPosition, ref]);

  const handleOnScroll = useCallback(
    (e: React.UIEvent<HTMLElement>) => {
      const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
      if (clientHeight === scrollHeight) {
        setShadowPosition(ShadowPosition.NONE);
        return;
      }
      if (scrollTop === 0) {
        setShadowPosition(ShadowPosition.TOP);
        return;
      }
      setShadowPosition(ShadowPosition.BOTTOM);
    },
    [setShadowPosition],
  );

  const containerShadowGradient = useMemo(() => {
    switch (shadowPosition) {
      case ShadowPosition.BOTTOM:
        return '0 5px 12px -7px rgba(0,0,0,.4)';
      case ShadowPosition.TOP:
      case ShadowPosition.NONE:
      default:
        return '';
    }
  }, [shadowPosition]);

  return { shadowPosition, handleOnScroll, containerShadowGradient };
};
